
   <template>
  <div>
      <v-container fluid class="pa-0">
        <HeaderBar/>
      </v-container>
  </div>
</template>


<script>
import Header from "@/components/shared/Header";
export default {
  components: {
    HeaderBar: Header,
  },
};
</script>